import React, { useContext, useEffect, useState } from "react";

import ZoomControl from "./Components/ZoomControl/Zoom";
import "./MapControls.scss";
import BaseLayerSelector from "./Components/BaseLayerSelector/BaseLayerSelector";

import { CenterAoiControl } from "./Components/CenterAoiControl/CenterAoiControl";
import { ExitPhotointerpretationModeButton } from "./Components/ExitPhotointerpretationModeButton/ExitPhotointerpretationModeButton";
import { resetRotation } from "../../../services/MapCore/MapService";
import { ResetRotationButton } from "./Components/ResetRotationButton/ResetRotationButton";
import AppContext from "../../Contexts/AppContext";
import { SettingsButton } from "./Components/SettingsButton/SettingsButton";
import { ExitDrawPolygonModeButton } from "./Components/ExitDrawPolygonModeButton/ExitDrawPolygonModeButton";
import { CenterUserControl } from "./Components/CenterUserControl/CenterUserControl";

const ControlPanel = ({ map }) => {
  const [isRotated, setIsRotated] = useState(false);
  const { mapControlsRef } = useContext(AppContext);

  useEffect(() => {
    if (!map) return;

    const view = map.getView();

    const handleRotationChange = () => {
      const rotation = view.getRotation();
      setIsRotated(rotation !== 0);
    };

    view.on("change:rotation", handleRotationChange);

    // Limpiar el evento al desmontar
    return () => {
      view.un("change:rotation", handleRotationChange);
    };
  }, [map]);

  return (
    <div className="control-panel" ref={mapControlsRef}>
      <ExitPhotointerpretationModeButton />
      <ExitDrawPolygonModeButton />
      <SettingsButton map={map} />
      {isRotated && <ResetRotationButton map={map} />}
      <ZoomControl map={map} />
      <CenterUserControl map={map} />
      <CenterAoiControl map={map} />
      <BaseLayerSelector map={map} />
    </div>
  );
};

export { ControlPanel };
